@if (stempelService.message(); as message) {
  <div
    class="absolute left-0 right-0 mx-auto z-[1000] flex justify-center mt-8 select-none"
    @fadeIn
  >
    <div
      class="w-[60vw] px-4 py-8 bg-success-200 text-center rounded shadow-lg overflow-hidden flex flex-col gap-2 justify-center border-4 border-success-800 border-solid"
    >
      <div
        class="font-semibold"
        [ngClass]="
          message.stempel?.kzkg !== 'G' && message.stempel?.kzkg !== 'K'
            ? 'text-[4rem]'
            : 'text-4xl '
        "
      >
        Stempel erfasst
      </div>
      @if (message?.stempel?.kzkg === 'G' || message?.stempel?.kzkg === 'K') {
        <div class="text-[5rem] font-bold uppercase text-success-800">
          {{ message?.stempel?.kzkg === 'K' ? 'KOMMT' : 'GEHT' }}
        </div>
      }
      @if (message.message) {
        <div class="text-xl text-light">{{ message.message }}</div>
      }
    </div>
  </div>
  <div
    class="absolute animate-pulse z-[1000] w-[20px] left-0 top-0 bottom-0 bg-success"
  ></div>
  <div
    class="absolute animate-pulse z-[1000] w-[20px] right-0 top-0 bottom-0 bg-success"
  ></div>
}

<router-outlet></router-outlet>
